'use client';

import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Button from '~/components/commonUi/Button/Button';
import Fieldset from '~/components/commonUi/Fieldset';
import Input from '~/components/commonUi/Input/Input';
import { getStore } from '~/mobx/AppStore';

interface Props {
    email?: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
}

const ExportReport = (props: Props) => {
    const { email = '', onChange, onSubmit } = props;
    const classNamesContainer = `flex flex-col md:flex-row md:items-center mb-4`;
    const classNamesLabel = `flex mb-2 font-normal md:mr-2 md:mb-0`;
    const classNamesInput = `w-full mb-3 md:w-[215px] md:mr-2 md:mb-0`;
    const classNamesButton = `w-full md:w-auto`;

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onSubmit();
    };

    const renderExportForm = () => {
        return (
            <form id="frm_export" method="post" onSubmit={handleFormSubmit}>
                <div className={classNamesContainer}>
                    <label htmlFor={'to'} className={classNamesLabel}>
                        E-post adresse:
                    </label>
                    <Input
                        extendedClassName={classNamesInput}
                        name={'to'}
                        id={'to'}
                        placeholder="E-post adresse"
                        testId={'to'}
                        type={'email'}
                        value={email}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    <Button
                        extendedClassName={classNamesButton}
                        btnText={'Lag og send fil..'}
                        testId={'create-btn'}
                        type="submit"
                    />
                </div>
            </form>
        );
    };

    return (
        <div className="frm-export overflow-x-auto">
            <Fieldset title={'Rapport Fil'}>
                <>
                    <div className="mb-4">Få tilsendt valgresultater i kommaseparert fil.</div>
                    {renderExportForm()}
                </>
            </Fieldset>
        </div>
    );
};

const ExportReportWithStore = () => {
    const { reportStore, regionStore } = getStore();

    useEffect(() => {
        reportStore.setEmail('');
    }, [regionStore.selectedRegionId, reportStore]);

    return (
        <ExportReport
            onChange={reportStore.onEmailChange}
            email={reportStore.email}
            onSubmit={reportStore.sendReportEmail}
        />
    );
};

export default observer(ExportReportWithStore);
